import { Div, not } from 'alkali'
import Icon from 'components/Icon'
import * as plus from 'icons/add-bold.svg'
import * as pencil from 'icons/pencil-2.svg'

export default class EditToggle extends Div('.edit-toggle') {
	created(props) {
		props.content = [
			Div('.add-link', {
				classes: {
					active: not(props.editing),
					inactive: props.editing
				},
				onclick() {
					props.editing.put(false)
				}
			}, [
				Icon({ icon: plus }), 'Add'
			]),
			Div('.edit-link', {
				title: props.editing.to(e => !e ? 'Load extracted data from Extraction History' : undefined),
				classes: {
					active: props.editing,
					inactive: not(props.editing),
					disabled: not(props.editing)
				}
			}, [
				Icon({ icon: pencil }), 'Edit'
			])
		]
	}
}